import { render, staticRenderFns } from "./AddRadishDrawer.vue?vue&type=template&id=8dcdf344&scoped=true&"
import script from "./AddRadishDrawer.vue?vue&type=script&lang=js&"
export * from "./AddRadishDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddRadishDrawer.vue?vue&type=style&index=0&id=8dcdf344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcdf344",
  null
  
)

export default component.exports